import YesNoChoices from "./yes-no-choice";
import { IInfraConfig } from "../experiments-and-innovations/redux";
import { ApplicationFormData } from "../redux";
import { replaceInvalidGitHubRepoNameCharactersWithHyphens } from "../utils/process-fields";
export const prefixApplicationNameToGitHubRepos = (
  githubRepos: Array<{ name: string }> | undefined,
  applicationName: string,
) => {
  const prefix = `${replaceInvalidGitHubRepoNameCharactersWithHyphens(applicationName)}`;
  return githubRepos?.map(
    (repo) => repo.name ? `${prefix}-${repo.name}` : prefix,
  ) ?? [];
};

export const getGcpProjectNameIfNeeded = (app: ApplicationFormData) =>
  isHostingServiceNeeded(app) ? app.infraConfig.gcpProjectName.trim() : "";

export const getGcpProjectNames = (gcpProjects: IInfraConfig["gcpProjects"]) => gcpProjects?.map(
  (project) => project.name.trim() ?? "",
);
export const getGcpProjectNamesIfNeeded = (app: ApplicationFormData) =>
  isHostingServiceNeeded(app) ? getGcpProjectNames(app.infraConfig.gcpProjects) : [];

export const getGitHubRepoIfNeeded = (app: ApplicationFormData) => {
  if (!isCodeRepositoryNeeded(app)) {
    return [];
  }
  const githubRepos = "githubRepos" in app.infraConfig ? app.infraConfig.githubRepos : undefined;
  return prefixApplicationNameToGitHubRepos(githubRepos, app.basicInfo.projectName);
};

export const getGithubOrganisationIfNeeded = (application: ApplicationFormData) => {
  if (!isCodeRepositoryNeeded(application)) {
    return "";
  }
  const app = application as { infraConfig: { githubOrganisation?: string } };
  return app.infraConfig.githubOrganisation ? app.infraConfig.githubOrganisation : "";
};


export const isCodeRepositoryNeeded = (application: ApplicationFormData) =>
  application.infraConfig.isCodeRepositoryNeeded === YesNoChoices.YES;

export const isHostingServiceNeeded = (application: ApplicationFormData) =>
  application.infraConfig.isHostingServiceNeeded === YesNoChoices.YES;

export const isCiCdPipelineNeeded = (application: ApplicationFormData) =>
  application.infraConfig.isCodeRepositoryNeeded === YesNoChoices.YES
  && application.infraConfig.isCiCdPipelineNeeded === YesNoChoices.YES;

export const isInfrastructureNeeded = (application: ApplicationFormData) =>
  isCodeRepositoryNeeded(application) || isHostingServiceNeeded(application);

export const getApplicationCategoryIfOthers = (app: ApplicationFormData) => {
  const indexOfOtherValue = app.basicInfo.projectCategory.findIndex((category) => (category === "other") || (category === "Others"));
  if (indexOfOtherValue > -1) {
    const projectCategory = [...app.basicInfo.projectCategory];
    projectCategory.splice(indexOfOtherValue, 1);
    return [...projectCategory, ...app.basicInfo["projectCategory-Comment"].split(",")];
  }
  return app.basicInfo.projectCategory;
};

export const getTechStackIfOthers = (app: ApplicationFormData) => {
  const indexOfOtherValue = app.basicInfo.techStack.indexOf("other");
  if (indexOfOtherValue !== -1) {
    const techStack = [...app.basicInfo.techStack];
    techStack.splice(indexOfOtherValue, 1);
    const otherTechStack = app.basicInfo["techStack-Comment"];
    return [...techStack, ...otherTechStack.split(",")];
  }
  return app.basicInfo.techStack;
};
